import { useRedux } from "hooks";
import React, { useEffect, useState } from "react";
import {
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Input,
    Spinner,
} from "reactstrap";
import { createSelector } from "reselect";
import Loader from "./Loader";
import { generateGroupInviteCodeAsync, getGroupInviteCodeAsync, applyUserToGroupAsync } from "../api/chats";
import { delGroupFromUser, setUserGroups } from "../redux/profile2/p2_reducer";
import { Exception } from "sass";
import { Utils } from "helpers/utils";



interface InviteCodeModalProps {
    isOpen: boolean;
    onClose: () => void;
    onReloadChatList: () => void;
}

const InviteCodeModal = ({
    isOpen,
    onClose,
    onReloadChatList
}: InviteCodeModalProps) => {

    const { dispatch, useAppSelector } = useRedux();
    const storeData = createSelector(
        (state) => state.Profile2,
        (state) => ({
            // groupInviteCode: state.groupInviteCode,
            // groupInviteOn: state.groupInviteOn,
            profile2: state
        })
    );
    const { /*groupInviteCode, groupInviteOn,*/ profile2 } = useAppSelector(storeData);
    // console.log('profile2:', profile2);
    const [isGenCode, setIsGenCode] = useState<boolean>(false);
    const [errMessage, _a1] = useState<string>("");
    const [errClass, _a2] = useState<string>("danger");
    const [groupInviteCode, setGroupInviteCode] = useState('');
    const [groupInviteJoin, setGroupInviteJoin] = useState('');
    // console.log('profile2:', profile2);

    useEffect(() => {
        // console.log('profile2-2:', profile2);
        const fetch = async () => {
            await getGroupInviteCodeAsync(profile2.activeGroupId)
                .then(response => {
                    setGroupInviteCode(response);
                })
                .catch(err => console.error(err));
        }
        fetch();
    }, []);

    const fnSetMsg = (err: boolean, msg: string) => {
        _a1(msg);
        _a2(err ? "danger" : "success");
    }

    const onCopyClick = async () => {
        if (groupInviteCode) {
            await navigator.clipboard.writeText(groupInviteCode);
            fnSetMsg(false, "คัดลอกลงคลิปบอร์ดแล้ว");
        } else {
            fnSetMsg(true, "ยังไม่มีรหัส, กรุณาสร้างรหัสก่อน");
        }
    }

    const fnGenCodeClick = async () => {
        if (!Utils.IsViewAsAlert()) {

            fnSetMsg(false, "กำลังประมวลผล");
            setIsGenCode(true);
            generateGroupInviteCodeAsync(profile2.activeGroupId)
                .then(result => {
                    // console.log(result);
                    if (result.success) {
                        fnSetMsg(false, "ประมวลผลสำเร็จ");
                        setGroupInviteCode(result.data);
                    } else {
                        fnSetMsg(true, result.message);
                    }
                    setIsGenCode(false);
                })
                .catch(error => {
                    fnSetMsg(true, (error as Exception).message);
                    setIsGenCode(false);
                    // console.log(error);
                });
        }
    }

    const onConfirmCode = (event: any) => {
        if (Utils.IsViewAsAlert()) return false;

        event.preventDefault();
        try {
            const code = groupInviteJoin;
            if (!code) {
                fnSetMsg(true, 'ยังไม่ได้ระบุรหัส');
            } else {
                fnSetMsg(true, 'ประมวลผล');
                applyUserToGroupAsync(profile2.userId, code)
                    .then((response) => {
                        if (response.message) {
                            fnSetMsg(true, response.message);
                        } else {
                            dispatch(setUserGroups(response));
                            onReloadChatList();
                            onClose();
                        }
                    })
                    .catch(error => {
                        fnSetMsg(true, (error as Error).message);
                    });

                // dispatch(applyUserToGroup(-1, -1, ));

            }
        } catch (e) {
            alert((e as Error).message);
        }
        return false;
    }

    return (
        <Modal isOpen={isOpen} toggle={onClose} tabIndex={-1} centered scrollable >
            <ModalHeader className="bg-primary" toggle={onClose}>
                <div className="modal-title-custom text-white font-size-16 ">
                    รหัสห้องแชท
                </div>
            </ModalHeader>
            <ModalBody className="p-4">
                <Form>
                    {errMessage && (
                        <div className="mb-3">
                            <div className={"alert alert-" + errClass + " text-center"}>{errMessage}</div>
                        </div>
                    )}

                    {/* อันนี้ code เก่า สำหรับสรร้างรหัสห้องแชท */}
                    {/* <div className="mb-3">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <button className="btn btn-outline-secondary" type="button" onClick={fnGenCodeClick}>
                                    {isGenCode && (<Loader size={"sm"}></Loader>)}
                                    {!isGenCode && ("สร้างรหัส")}
                                </button>
                            </div>
                            <input type="text" className="form-control invite-code" readOnly={true} aria-label="Amount (to the nearest dollar)" value={groupInviteCode} />
                            <div className="input-group-append">
                                <button className="btn btn-outline-secondary" type="button" onClick={onCopyClick}>คัดลอก</button>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="text-center">
                            นำรหัสนี้ไปกรอกตอนสมัคร เพื่อเข้าร่วมกลุ่ม
                        </div>
                    </div> */}

                    {/* ปรับ code ใหม่เป็นสมัครเข้า ห้องแชทแทน */}
                    <div className="mb-3">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <button className="btn btn-outline-secondary" type="button" >รหัสห้องแชท</button>
                            </div>
                            <input type="text" className="form-control invite-code" aria-label="Amount (to the nearest dollar)" onChange={(e) => setGroupInviteJoin(e.target.value)} value={groupInviteJoin} />
                            <div className="input-group-append">
                                <button className="btn btn-outline-secondary" type="button" onClick={(e) => onConfirmCode(e)}>เข้าร่วม</button>
                            </div>
                        </div>
                    </div>

                </Form>
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="link" className="btn" onClick={onClose} >
                    ปิด
                </Button>
                {/* <Button
                    type="button"
                    color="primary"
                    // disabled={!valid}
                    onClick={() => onInvite(data)}
                >
                    Invite
                </Button> */}
            </ModalFooter>
        </Modal>
    );
};

export default InviteCodeModal;
